/* eslint-disable react/style-prop-object */
/* eslint-disable max-len */
import { FC } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Card, CardContent, Container, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import classes from "./style";

const ConfidentialityPage: FC<{}> = () => {
  const rows = [
    {
      finalite: "Assurer le Service que rend CALARE à ses Membres",
      duree: "Toute la durée de la relation contractuelle",
      base: "Exécution du contrat (article 6.1 b RGPD)"
    },
    {
      finalite: "Gestion et suivi de la relation client",
      duree: "TROIS (3) ans à compter du dernier contact émanant du client",
      base: "Exécution du contrat (article 6.1 b RGPD)"
    },
    {
      finalite: "Exécution et amélioration du Service et fonctionnalités du Site web CALADRE",
      duree: "TROIS (3) ans à compter du dernier contact émanant du client",
      base: "Intérêt légitime (article 6.1 f RGPD)"
    },
    {
      finalite: "Assurer l’intérêt légitime de la sécurité du système d’information et du Site web CALADRE",
      duree: "UN (1) an à compter de la collecte des Données",
      base: "Intérêt légitime (article 6.1 f RGPD)"
    },
    {
      finalite: "Prévention des fraudes",
      duree: "Durée de la prescription légale",
      base: "Intérêt légitime (article 6.1 f RGPD)"
    },
    {
      finalite: "Gestion des demandes d’exercices des droits relatifs au RGPD",
      duree: "UN (1) an à compter de la demande d’exercice des droits",
      base: "Obligation légale (article 6.1 c RGPD)"
    }
  ];

  return (<>
    <Container disableGutters maxWidth={false} sx={classes.authContainer}>
      <Box sx={{ width: '90%' }}>
        <Card sx={{ ...classes.card, borderTopLeftRadius: "15px !important", height: "100%", position: "relative" }}>
          <CardContent
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%",
            }}
          >
            <Box sx={{ mt: 2 }}>
              <Typography sx={classes.label}>POLITIQUE DE PROTECTION DES DONNÉES A CARACTÈRE PERSONNEL</Typography>
              <Typography>
                <Typography fontWeight='bold'>1 En quoi consiste une politique de protection des données à caractère
                  personnel ?</Typography>
                1.1 La politique de protection des données à caractère personnel de CALADRE a pour
                objet d’informer les Visiteurs et les Membres du Site web CALADRE du traitement
                de leurs données à caractère personnel et des informations relatives à leur
                navigation sur le Site web CALADRE qui sont conformes au règlement UE 2016/679
                du 27 avril 2016 &quot;RGPD&quot;, et à la loi n°78-17 du 6 janvier 1978 relative à
                l’informatique, aux fichiers et aux libertés &quot;LIL&quot;.
                <br /><br /><Typography fontWeight='bold'>2 À qui s’adresse cette de protection des données personnelles ?</Typography>
                2.1 En visitant le Site web de CALADRE, le Visiteur et le Membre de CALADRE
                acceptent la politique de protection des données à caractère personnel et la
                politique cookie, quel que soit le terminal qu&#39;ils utilisent.
                <br />2.2 Le Visiteur et le Membre sont invités à ne pas poursuivre leur navigation sur le Site
                web de CALADRE et à ne plus utiliser le Service s’ils n’acceptent pas la politique de
                protection des données à caractère personnel et la politique cookie.
                <br />2.3 CALADRE attire l’attention de son Visiteur et de son Membre que les mots ci-
                dessous ont le sens suivant :
                <ul>
                  <li>&quot;Site web&quot; désigne le site web accessible depuis l&#39;URL :
                    https://www.caladre.com/</li>
                  <li>&quot;Service&quot; désigne le service de mise en relation de CALADRE pour partager
                    un voyage et de pouvoir échanger avec d&#39;autres Membres CALADRE.</li>
                  <li>&quot;Visiteur&quot; désigne la personne physique qui navigue sur le Site web
                    CALADRE depuis son terminal via un réseau de communications
                    électroniques à titre personnel en qualité de consommateur.</li>
                  <li>&quot;Membre&quot; désigne un Visiteur qui s&#39;inscrit en ligne pour bénéficier du
                    Service.</li>
                </ul>

                <br />2.4 Les termes suivants ont le même sens que dans le RGPD : &quot;donnée à caractère
                personnel&quot; (article 4.1 RGPD), &quot;responsable de traitement&quot; (article 4.7 RGPD),

                &quot;sous-traitant&quot; (article 4.8 RGPD), &quot;traitement&quot; (article 4.2 RGPD), &quot;violation de
                données à caractère personnel&quot; (article 4.12 RGPD).
                <br /><br /><Typography fontWeight='bold'>3 La politique de protection des données à caractère personnel peut-elle
                  évoluer ? </Typography>
                3.1 La présente politique de protection des données à caractère personnel peut évoluer
                à tout moment en cas d’évolution légale, de jurisprudence ou de recommandation
                des autorités françaises (CNIL – Commission national de l’informatique et des
                libertés) et européenne (EDPB – European Data Protection Board) de protection des
                données personnelles.
                <br />3.2 La politique de protection des données à caractère personnel en vigueur est celle
                qui est disponible en ligne sur le Site web CALADRE à la date à laquelle le Visiteur
                et le Membre naviguent.
                <br />3.3 La nouvelle version de la politique de protection des données à caractère personnel
                sera communiquée au Visiteur et au Membre par tout moyen choisi par CALADRE
                (communication par courrier électronique, par exemple).
                <br /><br /><Typography fontWeight='bold'>4 Quelle collecte de mes données à caractère personnel ?  </Typography>
                4.1 Les données techniques collectées sont les suivantes :
                <ul><li>Données relatives à la navigation : les données issues des cookies, l’adresse IP, la
                  date, l’heure de connexion et/ou de la navigation, le type de navigateur et la langue
                  du navigateur ;</li></ul>
                <br />4.2 Les données non techniques collectées sont les suivantes :
                <ul><li>Données d’identification : le nom, le prénom, la civilité et la date de naissance ;</li>
                  <li>Données de connexion : l’identifiant et son courrier électronique;</li>
                  <li>Coordonnées : coordonnées téléphoniques, courrier électronique, pays de résidence,
                    pays de voyage.</li></ul>
                <br />4.3 Seulement les données à caractère personnel qui sont strictement nécessaires au
                regard des finalités du Service sont collectées (respect du principe de minimisation).
                <br /><br /><Typography fontWeight='bold'>5 Qui est le responsable du traitement de mes données personnelles ?</Typography>
                5.1 En collectant les données à caractère personnel désignées ci-dessus de ses
                Visiteurs et de ses Membres, CALADRE agit en qualité de « responsable de
                traitement ».
                <br /><br /><Typography fontWeight='bold'>6 Comment mes données à caractère personnel sont-elles collectées par
                  CALADRE ?</Typography>
                6.1 CALADRE collecte les données à caractère personnel de ses Visiteurs et de ses
                Membres (i) suite à l’utilisation du Site web CALADRE par le Visiteur ou le Membre
                ou (ii) directement auprès du Membre suite à l’utilisation de son Service, via la
                création d’un compte CALADRE.
                <br /><Typography fontWeight='bold'>7 Pourquoi CALADRE collecte mes données à caractère personnel ?</Typography>
                1 Les données à caractère personnel des Visiteurs et des Membres sont collectées
                par CALADRE pour plusieurs finalités :
                (i) Assurer le Service (article 6.1 b RGPD) ;
                (ii) Gestion et suivi de la relation client (article 6.1 b RGPD) ;
                (iii) Exécution et amélioration du Service et des fonctionnalités du Site web
                CALADRE (article 6.1 f RGPD) ;

                CONFIDENTIEL - page 16 sur 63 -

                (iv) Gestion de l’activité du Site web CALADRE (statistiques, mesure d’audience
                du Site web CALADRE et du Service, publicité contextuelle) (article 6.1 f
                RGPD) ;
                (v) Assurer l’intérêt légitime de la sécurité du système d’information et du Site
                web CALADRE (article 6.1 f RGPD) ;
                (vi) Prévention des fraudes (article 6.1 f RGPD) ;
                (vii) Gestion des demandes d’exercices des droits relatifs au RGPD (article 6.1 c
                RGPD).

                <br /><br /><Typography fontWeight='bold'>8 Sur quelles bases légales sont traitées les données à caractère personnel des
                  Membres ?</Typography>

                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Finalité</TableCell>
                        <TableCell>Durée de conservation</TableCell>
                        <TableCell>Base légale</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell>{row.finalite}</TableCell>
                          <TableCell>{row.duree}</TableCell>
                          <TableCell>{row.base}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>


                <br /><br /><Typography fontWeight='bold'>9 Qui sont les destinataires de mes données à caractère personnel ?</Typography>
                9.1 Les uniques destinataires de vos données à caractère personnel sont : CALADRE
                en qualité de responsable de traitement et son éventuel prestataire de service sous-
                traitant au sens du RGPD.
                <br />9.2 CALADRE s’assure du respect par son sous-traitant de ses obligations (article 28
                RGPD).
                <br />9.3 Aucune donnée à caractère personnel d’un Visiteur ou d’un Membre collectée
                par CALADRE n’est communiquée et/ou vendue à un tiers.
                <br /><br /><Typography fontWeight='bold'>10 Mes données sont-elles transférées en dehors de l’Union européenne ?</Typography>
                10.1 CALADRE ne transfère aucune donnée à caractère personnel hors de l&#39;Union
                européenne.
                <br /><br /><Typography fontWeight='bold'>11 Comment mes données à caractère personnel sont-elles sécurisées ?</Typography>
                11.1 CALADRE met en œuvre des mesures techniques et organisationnelles appropriées
                pour assurer (i) le respect des données à caractère personnel de ses Visiteurs et de

                ses Membres qu’il aurait collecté et (ii) la confidentialité, l’intégrité, la disponibilité et
                la résilience constantes de son système d’information. (article 32 RGPD).
                <br /><br /><Typography fontWeight='bold'>12 Quels sont mes droits quant au traitement de mes données à caractère
                  personnel ?</Typography>
                12.1 Droit d’accès : le Visiteur et le Membre disposent du droit de demander à CALADRE
                une copie des données à caractère personnel qui sont traitées par CALADRE
                (article 15 RGPD).
                <br />12.2 Droit de rectification : le Membre peut lui-même rectifier ou de mettre à jour ses
                données à caractère personnel que CALADRE aurait enregistrées dans son compte
                CALADRE (article 16 RGPD).
                <br />12.3 Droit à la portabilité : le Membre peut demander à CALADRE de récupérer les
                données à caractère personnel qu’il a transmis à CALADRE pour utiliser son
                Service pour un usage personnel ou afin de les transmettre à un tiers de son choix.
                Ses données lui seront transmises dans un format structuré, facilement lisible par
                un autre système d’information (article 20 RGPD).
                <br />12.4 Droit d&#39;opposition à prospection : lorsque les données à caractère personnel d’un
                Membre ou d’un Visiteur sont traitées à des fins de prospection, le Membre ou le
                Visiteur concerné a le droit de s’opposer à tout moment au traitement des données
                à caractère personnel le concernant à de telles fins de prospection, y compris au
                profilage dans la mesure où il est lié à une telle prospection (21.2 RGPD).
                <br /><br /><Typography fontWeight='bold'>13 Comment puis-je exercer mes droits ?</Typography>
                13.1 Pour pouvoir exercer ses droits sur le traitement de ses données à caractère
                personnel, le Visiteur et le Membre peuvent contacter CALADRE via le courrier
                électronique suivant : contact@caladre.com
                <br />13.2 Le Visiteur et le Membre peuvent contacter CALADRE à tout moment pour exercer
                leurs droits sur ses données à caractère personnel.
                <br />13.3 En cas de litige avec CALADRE, le Visiteur et le Membre dispose du droit de saisir
                la Commission Nationale de l’Informatique et des Libertés (CNIL).
                <br /><br /><Typography fontWeight='bold'>14 Que se passe-t-il en cas de violation de mes données à caractère personnel ?</Typography>
                14.1 En cas de constatation d’une violation de données à caractère personnel collectées
                par CALADRE, CALADRE notifiera celle-ci à la CNIL dans les 72 heures au plus
                tard après en avoir pris connaissance (article 33 RGPD).
                <br />14.2 Si la violation des données à caractère personnel des Visiteurs et des Membres est
                susceptible de leur engendrer un risque élevé, CALADRE communiquera alors aux
                Visiteurs et aux Membres concernés (i) l’existence de cette violation de leurs
                données à caractère personnel dans les meilleurs délais et (ii) d’un point de contact
                auquel les Visiteurs et les Membres peuvent obtenir des informations
                supplémentaires, (iii) les conséquences probables de cette violation de données à
                caractère personnel, et (iv) les mesures prises par CALADRE ou que CALADRE
                propose de prendre pour remédier à cette violation de données à caractère
                personnel ou pour en atténuer les éventuelles conséquences négatives (article 34
                RGPD).
                <br /><br /><Typography fontWeight='bold'>15 Qui puis-je contacter si je souhaite obtenir plus d’information ?</Typography>
                15.1 Si un Visiteur ou un Membre souhaite obtenir des informations supplémentaires, il
                peut contacter : contact@caladre.com


              </Typography>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Container >
  </>
  );
};

export default ConfidentialityPage;
